<template>
  <v-card flat class="white vetalfa-view" :max-width="_getMaxWidth()">
    <div class="vetalfa-header" ref="screenHeader">
      <v-card
        flat
        elevation="0"
        class="items-top-bar"
        :max-width="_getMaxWidth()"
      >
        <vetalfa-small-header :title="headerTitle" :hasSlotOption="true">
          <items-filter
            class="vetalfa-max-width ma-0 pa-0 vetalfa-pointer"
            v-if="!loading && showFilters"
            :showFilters="showFilters"
            v-on:applyFilters="applyFilters"
          ></items-filter>
        </vetalfa-small-header>
        <v-row class="ma-0 pa-0 mt-2 mx-3">
          <v-col
            class="ma-0 pa-0"
            :cols="
              !!category &&
              !category.hideBrandSelection &&
              !hideBrand &&
              !loading
                ? 8
                : 12
            "
          >
            <v-text-field
              dense
              outlined
              clearable
              :value="autocomplete"
              :disabled="loading"
              :loading="loading"
              v-model="autocomplete"
              :placeholder="_getLabel('SEARCH_TEXT')"
              :prepend-inner-icon="icons.mdiMagnify"
            >
            </v-text-field>
          </v-col>
          <v-col
            v-if="
              !!category &&
              !category.hideBrandSelection &&
              !hideBrand &&
              !loading
            "
            class="ma-0 pa-0"
            :cols="4"
          >
            <v-row
              @click="toggleShowProducts()"
              align="center"
              justify="end"
              class="items-filter-products-selector pa-0 ma-0 pb-3"
            >
              <span class="items-filter-products-selector-text">{{
                labels.DRUGS_BRANDS
              }}</span>
              <div
                v-bind:class="
                  displayProducts
                    ? 'items-filter-products-selector-on'
                    : 'items-filter-products-selector-off'
                "
                class="ml-1"
              >
                <div class="items-filter-products-selector-toggle"></div>
              </div>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
    </div>
    <div ref="screenContent">
      <v-skeleton-loader
        v-if="loading"
        class="ma-0 pa-0"
        :type="skeletonType"
      ></v-skeleton-loader>
      <div v-if="!loading && scrollHeight != 0">
        <v-snackbar
          style="position: absolute; bottom: 0px"
          density="compact"
          class="white--text"
          color="primary"
          dark
          timeout="-1"
          dismissible
          bottom
          v-model="snackbar"
          :value="snackbar"
        >
          Teste por 10 dias grátis
          <template v-slot:action="{ attrs }">
            <v-btn
              x-small
              color="white"
              icon
              v-bind="attrs"
              @click="snackbar = false"
            >
              <v-icon>{{ icons.mdiClose }}</v-icon>
            </v-btn>
          </template>
        </v-snackbar>
        <v-virtual-scroll
          v-if="itemsList.length"
          :items="itemsList"
          :item-height="itemsHeight"
          :bench="0"
          :height="scrollHeight"
          id="items-virtual-scroll"
        >
          <template v-slot="{ item, index }">
            <div>
              <div v-if="item.name">
                <v-row
                  v-if="isPhotosCategory"
                  @click="openSection(item)"
                  class="ma-0 pa-0 px-2"
                  v-bind:style="itemRow"
                  align="center"
                >
                  <v-card height="140" width="100%" elevation="2">
                    <v-row class="ma-0 pa-0 vetalfa-row" align="center">
                      <v-img
                        max-width="100px"
                        height="100px"
                        position="center"
                        :src="item.photo"
                        contain
                        style="border-radius: 5px"
                      >
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height ma-0"
                            align="center"
                            justify="center"
                          >
                            <v-progress-circular
                              width="2"
                              indeterminate
                              color="primary"
                            ></v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                      <v-col
                        :cols="$vuetify.breakpoint.xsOnly ? 7 : 9"
                        class="ma-0 pa-0 pr-2 pl-4"
                        style="height: 100%"
                      >
                        <p
                          class="ma-0 pa-0 vetalfa-dialog-title text-left mt-2 pt-2"
                        >
                          {{ item.name }}
                        </p>
                        <p
                          class="ma-0 pa-0 vetalfa-card-text primary--text text-left"
                        >
                          {{ item.brand }}
                        </p>
                        <p
                          class="ma-0 pa-0 vetalfa-card-text-disabled text-left mt-4"
                          v-bind:style="`display:-webkit-box;-webkit-line-clamp:${
                            !$vuetify.breakpoint.xsOnly
                              ? '2'
                              : item.name.length > 30
                              ? '1'
                              : '3'
                          };-webkit-box-orient:vertical;overflow:hidden;text-overflow:ellipsis;`"
                        >
                          {{ item.drugs ? ` ${item.drugs.join("; ")}` : "" }}
                        </p>
                        <v-icon
                          class="items-arrow-button"
                          x-small
                          color="#747678"
                          >{{ icons.mdiChevronRight }}</v-icon
                        >
                      </v-col>
                    </v-row>
                  </v-card>
                </v-row>
                <v-row
                  v-else-if="item.name"
                  @click="openSection(item)"
                  class="ma-0"
                  v-bind:style="itemRow"
                  align="center"
                >
                  <v-card
                    outlined
                    :height="`53px`"
                    style="
                      width: 100%;
                      border: 1px solid #eeeeee !important;
                      border-radius: 10px;
                    "
                    class="ma-0 pa-0 white mx-2 px-2"
                  >
                    <v-row class="ma-0 pa-0 vetalfa-row" align="center">
                      <v-col :cols="11" class="ma-0 pa-0">
                        <v-row class="ma-0 pa-0" align="center">
                          <p
                            v-bind:class="
                              (item.type
                                ? 'items-products-title'
                                : 'items-title') +
                              (!!isPathParameterMode
                                ? ' items-two-lines-clamp'
                                : '')
                            "
                            v-html="item.name"
                            class="ma-0"
                          ></p>
                        </v-row>
                        <v-row class="ma-0 pa-0">
                          <p
                            v-if="!!isPathParameterMode || !!item.description"
                            class="items-description-label text-center mt-1 ma-0 pa-0"
                          >
                            {{ getDescription(item) }}
                          </p>
                          <p
                            v-else-if="item.type"
                            class="items-products-label-box text-center mt-1 ma-0 pa-0 px-1"
                          >
                            vet
                          </p>
                        </v-row>
                      </v-col>
                      <v-col :cols="1" class="ma-0 pa-0">
                        <v-row
                          v-if="
                            !isPremium &&
                            (item.premium || $route.params.subtopic)
                          "
                          justify="end"
                          class="ma-0 pa-0 pl-2 pr-0"
                        >
                          <v-icon small color="primary">
                            {{ icons.mdiLockOutline }}
                          </v-icon>
                        </v-row>
                        <v-row v-else justify="end" class="ma-0 pa-0 pr-1">
                          <v-icon x-small color="#747678">{{
                            icons.mdiChevronRight
                          }}</v-icon>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-row>
              </div>
              <v-row
                v-else-if="item.blank"
                v-bind:id="`blank-${index}`"
                align="center"
                justify="start"
                class="ma-0 pa-0 white"
              >
              </v-row>
              <v-row
                v-else
                v-bind:id="`letter-${item.letter}`"
                align="end"
                class="ma-0 pa-0"
                v-bind:style="`height: ${itemsHeight}px;`"
              >
                <v-row
                  align="end"
                  justify="start"
                  class="items-row-letter ma-0 pa-0 pl-3"
                >
                  <v-col :cols="item.brand ? 6 : 12" class="ma-0 pa-0">
                    <p class="pa-0 ma-0">{{ item.letter }}</p>
                  </v-col>
                </v-row>
              </v-row>
            </div>
          </template>
        </v-virtual-scroll>
        <v-row
          v-if="itemsList.length == 0"
          justify="center"
          class="ma-0 pa-0 pt-5 mt-5"
        >
          <v-col class="ma-0 pa-0" cols="12">
            <v-row class="ma-0 pa-0" justify="center">
              <v-img
                position="center"
                height="100px"
                class="ma-0 pa-0"
                :src="images.NO_RESULTS"
                :lazy-src="images.NO_RESULTS"
                max-width="300"
                contain
              ></v-img>
            </v-row>
          </v-col>
          <v-col class="ma-0 pa-0 px-5" cols="12">
            <p class="vetalfa-card-title-disabled text-center ma-0 pa-0 mt-5">
              {{ _getLabel("NO_CONTENT") }}
            </p>
            <p class="vetalfa-card-text-disabled ma-0 pa-0 mt-1">
              {{
                isPathParameterMode
                  ? _getLabel("SUGGEST_CONTENT")
                  : _getLabel("SEARCH_OR_SUGGEST_CONTENT")
              }}
            </p>
          </v-col>
          <v-col class="ma-0 pa-0 mt-5" cols="12">
            <v-row class="ma-0 pa-0" justify="center">
              <v-btn
                class="text-none mb-2"
                color="primary"
                elevation="5"
                v-if="!isPathParameterMode"
                @click="searchOnVetAlfa()"
                >{{ _getLabel("SEARCH_ON_VET_ALFA") }}
              </v-btn>
            </v-row>
          </v-col>
          <v-col class="ma-0 pa-0 mt-5" cols="12">
            <v-row class="ma-0 pa-0" justify="center">
              <v-btn
                class="text-none mb-2"
                v-bind:class="
                  isPathParameterMode
                    ? 'primary'
                    : 'primary--text  text-none text-decoration-underline'
                "
                :text="!isPathParameterMode"
                @click="suggestNewContent()"
                >{{ _getLabel("SUGGEST_CONTENT_BTN") }}
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
        <vetalfa-user-section :comunication="true"></vetalfa-user-section>
      </div>
    </div>
  </v-card>
</template>

<style>
.v-skeleton-loader__heading {
  margin: 8px 0px 8px 12px !important;
  height: 52px !important;
  width: 92% !important;
}
.v-skeleton-loader__chip {
  border-radius: 8px !important;
  height: 25px !important;
  width: 186px !important;
  margin-top: 24px !important;
  margin-left: 12px !important;
}
.items-two-lines-clamp {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 3px;
}
.items-back-button {
  position: absolute;
  left: 15px;
  top: calc(35px + env(safe-area-inset-top));
  cursor: pointer;
}
.items-arrow-button {
  position: absolute !important;
  right: 8px;
  top: 60px;
}
.items-title {
  color: #393a3a;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 14px;
  font-weight: normal;
}
.items-products-title {
  color: #393a3a;
  font-size: 14px;
  font-style: italic;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 14px;
}
.items-description-label {
  font-size: 10px;
  line-height: 10px;
  color: rgb(57, 58, 58, 0.52);
}
.items-products-label-box {
  box-sizing: border-box;
  border: 1px solid rgb(0, 114, 138, 0.14);
  border-radius: 10px;
  background-color: rgb(0, 114, 138, 0.14);
  font-size: 10px;
  line-height: 10px;
  color: rgb(57, 58, 58, 0.92);
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.35);
}
.theme--light.v-label {
  font-size: 14px !important;
}
.items-top-bar {
  border-radius: 0px !important;
  background: transparent;
  width: 100%;
  height: 130px;
}
.items-row-letter {
  background-color: white;
  width: 100%;
  font-size: 18px;
  font-weight: bold;
  color: #004662;
}

.items-filter-products-selector-text {
  color: #004662;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 14px;
}
.items-filter-products-selector-toggle {
  height: 12px;
  width: 12px;
  background-color: #ffffff;
  border-radius: 31.5px;
  border: 1px solid #004662;
}
.items-filter-products-selector-on {
  box-sizing: border-box;
  height: 17.45px;
  width: 35px;
  border: 1px solid #004662;
  background-color: #004662;
  border-radius: 31.5px;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: flex-end;
  align-content: center;
  align-items: center;
  display: -webkit-flex;
  -webkit-align-items: center;
  padding-right: 2px;
  padding-bottom: 0.5px;
}
.items-filter-products-selector-off {
  box-sizing: border-box;
  height: 17.45px;
  width: 35px;
  border: 1px solid #004662;
  background-color: transparent;
  border-radius: 31.5px;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: flex-start;
  align-content: center;
  align-items: center;
  display: -webkit-flex;
  -webkit-align-items: center;
  padding-left: 2px;
  padding-bottom: 0.5px;
}
.items-filter-products-selector {
  cursor: pointer;
  height: 50px;
}
</style>

<script>
import images from "@/constants/images.js";
import labels from "@/constants/labels.js";
import parameters from "@/constants/parameters.js";
import { mapActions, mapGetters, mapMutations } from "vuex";
import {
  mdiMagnify,
  mdiChevronRight,
  mdiClose,
  mdiChevronLeft,
  mdiLockOpenVariantOutline,
  mdiLockOutline,
} from "@mdi/js";
import searchDrugsList from "@/constants/searchDrugsList.js";
import ItemsFilter from "@/components/ItemsFilter.vue";
import categories from "@/constants/categories.js";
import UserSection from "@/components/UserSection.vue";
export default {
  name: "Items",
  watch: {
    autocomplete() {
      if (this.hasMounted) {
        this.filterSummary();
      }
    },
  },
  methods: {
    ...mapActions("drugs", ["openItemOrProduct", "openCategory"]),
    ...mapActions("preferences", ["getPreferencesByMode"]),
    ...mapActions("topics", ["openSubtopic", "openTopicItem"]),
    ...mapActions("calculators", ["openCalculatorById", "openCalculators"]),
    ...mapActions("general", [
      "openExternalUrl",
      "logEvent",
      "routePathRedirect",
    ]),
    ...mapMutations("general", ["setUserSection"]),
    ...mapMutations("drugs", [
      "setFeatures",
      "setDrugTab",
      "setShowProducts",
      "setVirtualScroll",
      "setSearchValue",
      "setItemsList",
      "setPresentationList",
      "setClassesList",
      "setBrandList",
      "setActivePrinciplesList",
      "setPetAges",
      "setPetSizes",
      "setPetBreeds",
      "setBrandLines",
    ]),
    searchOnVetAlfa() {
      this.logEvent("openGlobalSearchesFromItems");
      this.$router.replace({ path: "/items/searches" }).then(() => {
        this.handleMode();
      });
    },
    suggestNewContent() {
      this.logEvent("suggest_content_click");
      this.setUserSection(true);
    },
    getDescription(item) {
      return (
        item.description ||
        (!!item.topic
          ? item.topic
          : categories[item.category - 1].portugueseName)
      );
    },
    createListOfItems() {
      if (this.drugsSummary && this.productsSummary) {
        this.summary = [];
        if (this.category.orderByClasses) {
          this.filterItemsByClasses();
        } else {
          this.filterItemsByLetter();
        }

        this.summary = this.summary.sort((a, b) =>
          this._removeAccents(a.name) > this._removeAccents(b.name) ? 1 : -1
        );
        this.filterSummary();
      }
    },
    applyFilters() {
      this.displayProducts = true;
      this.filterSummary();
    },
    openSection(item) {
      if (this.category.id == 7 || item.category == 7) {
        this.openCalculatorById({ id: item.id });
      } else if (this.$route.params.subtopic || !!item.topic) {
        this.openTopicItem({ itemId: item.id, redirectMode: true });
      } else {
        this.openItemOrProduct(item);
      }
    },
    toggleShowProducts() {
      this.displayProducts = !this.displayProducts;
      this.filterSummary();
    },
    validateFilters(item) {
      const validPresentation =
        this.presentationFilter === undefined ||
        item.presentationList.includes(
          this.presentationList[this.presentationFilter]
        );
      const classToValidate =
        typeof this.classesFilter == "number"
          ? typeof this.systemFilter == "number"
            ? this.systemClasses[this.classesFilter]
            : this.classesList[this.classesFilter]
          : this.classesFilter;
      const validClass =
        this.classesFilter === undefined ||
        this.classesFilter === null ||
        item.classes.includes(classToValidate.trim());
      const validBrand =
        this.brandFilter === undefined ||
        this.brandFilter.length == 0 ||
        this.brandFilter.includes(item.brand);
      const validDrugs =
        this.activePrinciplesFilter === undefined ||
        this.activePrinciplesFilter.length == 0 ||
        this._doesArrayContainAllElementsOfAnother(
          item.drugs,
          this.activePrinciplesFilter
        );
      const validSystem = this.getValidSystem(item.classes);

      const validAges =
        this.petAgesFilter === undefined ||
        this.petAgesFilter.length == 0 ||
        this.petAgesFilter.every((age) => item.petAges.includes(age));
      const validSizes =
        this.petSizesFilter === undefined ||
        this.petSizesFilter.length == 0 ||
        this.petSizesFilter.every((size) => item.petSizes.includes(size));
      const validBreeds =
        this.petBreedsFilter === undefined ||
        this.petBreedsFilter.length == 0 ||
        this.petBreedsFilter.every((breed) => item.petBreeds.includes(breed));
      const validFeatures =
        this.featuresFilter === undefined ||
        this.featuresFilter.length == 0 ||
        this.featuresFilter.every((feature) => item.features.includes(feature));
      const validBrandLine =
        this.brandLinesFilter === undefined ||
        this.brandLinesFilter === null ||
        item.brandLines.includes(this.lines[this.brandLinesFilter]);
      return (
        (!this.dogFilter || item.dogs) &&
        (!this.catFilter || item.cats) &&
        validPresentation &&
        validClass &&
        validBrand &&
        validDrugs &&
        validSystem &&
        validAges &&
        validSizes &&
        validBreeds &&
        validFeatures &&
        validBrandLine
      );
    },
    getValidSystem(itemClasses) {
      if (
        !!this.systemClasses &&
        typeof this.systemFilter == "number" &&
        !this.classesFilter
      ) {
        for (const index in this.systemClasses) {
          if (itemClasses.includes(this.systemClasses[index])) {
            return true;
          }
        }
        return false;
      }
      return true;
    },
    filterSummary() {
      const filter =
        this._removeAccents(this.autocomplete.trim().toLowerCase()) || "";
      if (filter || this.category.displayProducts) {
        this.displayProducts = true;
      }
      let firstLetter = "";
      this.filtered = [];
      const fixedEntries = this.findFixedEntries(filter);
      if (!this.category.orderByClasses) {
        this.summary.forEach((s) => {
          let invalidFilters =
            (this.isPhotosCategory && !s.type) || !this.validateFilters(s);
          if (s.disabled || invalidFilters) {
            return;
          }
          const normalizedItemName = this._removeAccents(s.name.toLowerCase());
          const itemFoundFromFixedList = this.findItemFromDrugsFixedList(
            filter,
            normalizedItemName,
            fixedEntries,
            s.type
          );
          if (
            filter &&
            !normalizedItemName.includes(filter) &&
            !itemFoundFromFixedList
          ) {
            return;
          }
          if (!this.displayProducts && s.type) return;
          const itemFirstLetter = this._getUpperCaseFirstLetter(s.name);
          if (
            this._removeAccents(firstLetter) !==
              this._removeAccents(itemFirstLetter) &&
            !this.isPhotosCategory
          ) {
            firstLetter = this._removeAccents(itemFirstLetter);
            this.filtered.push({
              letter: firstLetter,
              id: firstLetter,
              brand: firstLetter === "A" && !this.category.hideBrandSelection,
            });
          }
          let newObj = Object.assign({}, s);
          newObj.name += itemFoundFromFixedList;
          this.filtered.push(newObj);
        });
      } else {
        for (var key in this.classes) {
          this.classes[key].items.forEach((classItem) => {
            const normalizedItemName = this._removeAccents(
              classItem.name.toLowerCase()
            );
            const itemFoundFromFixedList = this.findItemFromDrugsFixedList(
              filter,
              normalizedItemName,
              fixedEntries,
              classItem.type
            );
            if (
              filter &&
              !normalizedItemName.includes(filter) &&
              !itemFoundFromFixedList
            ) {
              return;
            }
            if (!this.displayProducts && classItem.type) return;
            if (this._removeAccents(firstLetter) !== this._removeAccents(key)) {
              const isBrandSection = firstLetter == "";
              firstLetter = key;
              this.filtered.push({
                letter: firstLetter,
                id: firstLetter,
                brand: isBrandSection && !this.category.hideBrandSelection,
              });
            }
            let newObj = Object.assign({}, classItem);
            newObj.name += itemFoundFromFixedList;
            if (!classItem.disabled) {
              this.filtered.push(newObj);
            }
          });
        }
      }
      if (this.filtered.length) {
        this.addBlankEntryToHandleScroll();
        if (!this._isCordovaApp()) {
          this.addBlankEntryToHandleScroll();
        }
      }
      let paddingTop = this.isPhotosCategory ? 0 : 40;
      paddingTop -= parseInt(
        window
          .getComputedStyle(
            document.getElementById("small-header-top-bar"),
            null
          )
          .getPropertyValue("padding-top")
          .replace("px", "") || 0
      );
      this._setupScreenSizes(this, paddingTop);
      this.manageVirtualScroll();
      this.setItemsList(this.filtered);
      this.filtered = [];
    },
    addBlankEntryToHandleScroll() {
      this.filtered.push({
        blank: true,
      });
    },
    findFixedEntries(filter) {
      let entries = [];
      if (filter) {
        entries = this.searchDrugsList.filter((s) => {
          return this._removeAccents(s[0]).toLowerCase().includes(filter);
        });
      }
      return entries;
    },
    findItemFromDrugsFixedList(filter, itemName, fixedEntries, type) {
      let itemFound = "";
      if (filter && !type) {
        fixedEntries.forEach((s) => {
          if (
            this._removeAccents(s[0]).toLowerCase().includes(filter) &&
            itemName.trim() == s[1]
          ) {
            itemFound = ` (${s[0]})`;
          }
        });
      }
      return itemFound;
    },
    manageVirtualScroll() {
      let el = document.getElementById("items-virtual-scroll");
      if (el == null) {
        setTimeout(this.manageVirtualScroll, 10);
        return;
      }
      if (el.scrollTop == 0) {
        el.scrollTop = this.getVirtualScroll;
      }
      if (el.scrollHeight - el.clientHeight - 1 < el.scrollTop) {
        el.scrollTop = el.scrollHeight - el.clientHeight - 1;
      }
      this.setVirtualScroll(el.scrollTop);
      el.addEventListener("scroll", this.manageVirtualScroll);
    },
    filterItemsByLetter() {
      let filterClasses = [],
        presentationList = [],
        brandList = [],
        activePrinciples = [],
        petSizes = [],
        petAges = [],
        petBreeds = [],
        features = [],
        brandLines = {};
      this.drugsSummary[this.category.collection].forEach((drug) => {
        filterClasses = filterClasses.concat(
          drug.classes || drug.categories || []
        );
        let itemToAdd = {
          name: drug.name,
          id: drug.id,
          disabled: drug.disabled,
          classes: drug.classes || drug.categories || [],
        };
        if (this.$route.params.subtopic) {
          drug.animals = drug.animals || [];
          itemToAdd["description"] = drug.description || null;
          itemToAdd["dogs"] = !!drug.animals.find((a) => {
            return a.value == 1;
          });
          itemToAdd["cats"] = !!drug.animals.find((a) => {
            return a.value == 2;
          });
        }
        this.summary.push(itemToAdd);
      });
      this.productsSummary[this.categoryProductsCollection].forEach(
        (product) => {
          if (product.type != 2) {
            let toAddProduct = {
              name: product.name,
              id: product.id,
              type: product.type,
            };

            filterClasses = filterClasses.concat(product.classes || []);
            toAddProduct["classes"] = product.classes || [];

            if (this.isPhotosCategory) {
              if ([6, 12, 13].includes(this.category.id)) {
                const filterPresentationList = product.presentationList.map(
                  (el) => {
                    return el.replaceAll("|", " | ");
                  }
                );
                presentationList = presentationList.concat(
                  filterPresentationList
                );
                toAddProduct["presentationList"] = filterPresentationList;

                toAddProduct["drugs"] = [];
                product.drugs.forEach((drug) => {
                  if (!drug.hasLink) {
                    const drugName = this._capitalizeAllFirstLetters(
                      drug.name.trim()
                    );
                    activePrinciples.push(drugName);
                    toAddProduct["drugs"].push(drugName);
                  }
                });
              } else if (this.category.foods) {
                toAddProduct["presentationList"] = [product.presentation];
                petSizes = petSizes.concat(product.petSizes);
                petAges = petAges.concat(product.petAges);
                petBreeds = petBreeds.concat(product.petBreeds);
                toAddProduct["petSizes"] = product.petSizes;
                toAddProduct["petAges"] = product.petAges;
                toAddProduct["petBreeds"] = product.petBreeds;
                features = features.concat(product.features);
                toAddProduct["features"] = product.features;
                if (product.presentation) {
                  presentationList.push(product.presentation);
                }
                if (!brandLines[product.brand.trim()]) {
                  brandLines[product.brand.trim()] = [];
                }
                brandLines[product.brand.trim()] = brandLines[
                  product.brand.trim()
                ].concat(product.brandLines);
                toAddProduct["brandLines"] = product.brandLines;
              }
              brandList.push(product.brand.trim());
              toAddProduct["dogs"] = product.dogs;
              toAddProduct["cats"] = product.cats;
              toAddProduct["photo"] = product.photo;
              toAddProduct["brand"] = product.brand.trim();
            }
            this.summary.push(toAddProduct);
          }
        }
      );
      this.setBrandLines(brandLines);
      this.setFeatures([...new Set(features)].sort());
      this.setPetAges(["Neonato", "Filhote", "Adulto", "Sênior"]);
      this.setPetSizes(["Mini", "Pequeno", "Médio", "Grande", "Gigante"]);
      this.setPetBreeds([...new Set(petBreeds)].sort());
      this.setClassesList([...new Set(filterClasses)].sort());
      this.setPresentationList([...new Set(presentationList)].sort());
      this.setBrandList([...new Set(brandList)].sort());
      this.setActivePrinciplesList(
        [...new Set(activePrinciples)].sort().filter(function (str) {
          return /\S/.test(str);
        })
      );
    },
    filterItemsByClasses() {
      this.classes = {};
      let miscClassItems = [];
      this.drugsSummary[this.category.collection].forEach((d) => {
        if (this._isPopulatedArray(d.classes)) {
          d.classes.forEach((c) => {
            if (!this.classes[c]) {
              this.classes[c] = { name: c, items: [] };
            }
            this.classes[c].items.push({
              name: d.name,
              id: d.id,
              disabled: d.disabled,
              premium: d.premium,
            });
          });
        } else {
          miscClassItems.push({
            name: d.name,
            id: d.id,
            disabled: d.disabled,
            premium: d.premium,
          });
        }
      });
      if (this.productsSummary[this.categoryProductsCollection]) {
        this.productsSummary[this.categoryProductsCollection].forEach((p) => {
          if (p.type != 2) {
            if (this._isPopulatedArray(p.classes)) {
              p.classes.forEach((c) => {
                if (!this.classes[c]) {
                  this.classes[c] = { name: c, items: [] };
                }
                this.classes[c].items.push({
                  name: p.name,
                  id: p.id,
                  type: p.type,
                });
              });
            } else {
              miscClassItems.push({
                name: p.name,
                id: p.id,
                type: p.type,
              });
            }
          }
        });
      }
      this.classes = {
        "Calculadoras de Infusão": this.classes["Calculadoras de Infusão"],
        Transfusão: this.classes["Transfusão"],
        ...Object.keys(this.classes)
          .sort()
          .reduce((obj, key) => {
            obj[key] = this.classes[key];
            return obj;
          }, {}),
      };
      this.classes[this.miscClass] = {
        name: this.miscClass,
        items: miscClassItems,
      };
    },
    async handleMode() {
      this.modeTries = this.modeTries + 1;
      if (this.modeTries > 3) {
        return;
      }
      this.loading = true;
      await this.getPreferencesByMode({ mode: this.$route.params.mode });
      if (this.preferences) {
        this.autocomplete = this.autocomplete || this.$route.query.search_query;
        if (this.category.orderByClasses) {
          this.classes = this.preferences;
        } else {
          this.summary = this.preferences;
          this.summary = this.summary.sort((a, b) =>
            this._removeAccents(a.name) > this._removeAccents(b.name) ? 1 : -1
          );
        }

        this.filterSummary();
        this.loading = false;
      } else {
        setTimeout(this.handleMode.bind(this), 2000);
      }
    },
  },
  computed: {
    ...mapGetters("drugs", [
      "lines",
      "drugsSummary",
      "productsSummary",
      "showProducts",
      "getVirtualScroll",
      "hasFilter",
      "getSearchValue",
      "category",
      "itemsList",
      "catFilter",
      "dogFilter",
      "presentationFilter",
      "presentationList",
      "classesFilter",
      "classesList",
      "brandFilter",
      "activePrinciplesFilter",
      "systemClasses",
      "systemFilter",
      "petAges",
      "petAgesFilter",
      "petSizes",
      "petSizesFilter",
      "petBreeds",
      "petBreedsFilter",
      "featuresFilter",
      "features",
      "brandLines",
      "brandLinesFilter",
    ]),
    ...mapGetters("topics", ["topic"]),
    ...mapGetters("preferences", ["preferences"]),
    ...mapGetters("general", ["isPremium"]),
    headerTitle() {
      if (this.$route.params.subtopic) {
        return this.topic ? this.topic.name : null;
      }
      return this.category ? this.category.portugueseName : null;
    },
    hideBrand() {
      return !!this.autocomplete || !!this.hasFilter;
    },
    itemsHeight() {
      return this.isPhotosCategory ? 150 : 63;
    },
    isPathParameterMode() {
      return this.$route.params.mode;
    },
    itemRow() {
      return `
          background-color: white;
          height: ${this.itemsHeight - 5}px;
          font-size: 16px;
          font-weight: bold;
          color: black;
          cursor: pointer !important;
        `;
    },
    showFilters() {
      return (
        ((!!this.category && !this.category.orderByClasses) ||
          !!this.$route.query.subtopic) &&
        !this.$route.params.mode
      );
    },
    isPhotosCategory() {
      return !!this.category && this.category.orderByPhotos;
    },
    displayProducts: {
      get() {
        return this.showProducts;
      },
      set(val) {
        this.setShowProducts(val);
      },
    },
    autocomplete: {
      get() {
        return this.getSearchValue;
      },
      set(val) {
        this.setSearchValue(val || "");
      },
    },
    categoryProductsCollection() {
      return this.category.id == 1
        ? "products"
        : this.category.productsCollection;
    },
  },
  components: {
    "items-filter": ItemsFilter,
    "vetalfa-user-section": UserSection,
  },
  data() {
    return {
      icons: {
        mdiLockOpenVariantOutline,
        mdiLockOutline,
        mdiMagnify,
        mdiChevronRight,
        mdiClose,
        mdiChevronLeft,
      },
      modeTries: 0,
      images,
      filtered: [],
      summary: [],
      labels,
      scrollHeight: 0,
      searchDrugsList: Object.entries(searchDrugsList),
      classes: {},
      miscClass: parameters.DRUGS_MISC_CLASS,
      hasFilterPadding: false,
      loading: false,
      hasMounted: false,
      snackbar: false,
      skeletonType:
        "chip,heading,chip,heading,heading,heading,heading,heading,chip,heading,heading,heading,heading,heading,chip,heading,heading,heading,heading",
    };
  },
  mounted: async function () {
    this.hasMounted = true;
    if (this.$route.params.mode) {
      await this.handleMode();
      return;
    }

    const summaryIsReady =
      !this.$route.params.subtopic &&
      !!this.drugsSummary &&
      !!this.productsSummary &&
      !!this.category &&
      this.$route.query.category == this.category.id;
    this.loading = true;

    if (!summaryIsReady) {
      if (this.$route.params.subtopic) {
        await this.openSubtopic(this.$route.params.subtopic);
      } else if (this.$route.query.category == 7) {
        await this.openCalculators();
      } else {
        await this.openCategory(this.$route.query.category);
      }
      this.displayProducts = this.category.displayProducts;
    }
    this.loading = false;
    return this.createListOfItems();
  },
  created() {
    this.setDrugTab(parameters.DRUGS_INFO_DEFAULT_TAB);
  },
};
</script>